module.exports = __webpack_public_path__ + "img/logo2.16d7cb59.png";